module.exports = __webpack_public_path__ + "static/img/37.58410440.png";